var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"transition-swing",class:_vm.$vuetify.breakpoint.xsOnly ? 'mx-n4' : '',attrs:{"id":_vm.$route.name}},[_c('FormMahasiswa',{attrs:{"appThemeColor":_vm.appThemeColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }